<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(color="primary" v-on="on" text) {{button}}
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ title }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        v-btn(@click="visible = !visible" color="primary" icon)
          v-icon(dark) mdi-pencil
        BaseDefinitionList(v-if="visible", :items="getDetailsProvider(provider)" keysAlign="text-left text-sm-right")
        OperatorProviderEdit(v-else :clearForm="!visible", :translations="translations", :operator="operator", :provider="provider" @successEdit="update()")
</template>

<script>

  import OperatorProviderEdit from '../forms/OperatorProviderEdit';

  export default {
    name: "OperatorProviderEditDialog",
    components: {
      OperatorProviderEdit,
    },
    props:{
      title:{
        type: String,
        default: ''
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      button:{
        type: String,
        default: ''
      },
      operator:{
        type: String,
        default: ''
      },
      provider:{
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() => ({
      dialog: false,
      visible: true,
    }),
    computed: {
      // translations() {
      //   return this.$t("forms.operatorProviderCreateEdit");
      // },
    },
    watch: {
      dialog: function(){
        this.visible = true;
      },
    },
    methods:{
      getDetailsProvider(provider){
        let fields = [
          {
            key: 'Short Name:',
            value: provider.p.c
          },
        ];
        if (this.provider.api != '' && this.provider.api != undefined){
          fields.push({
            key: 'API:',
            value: provider.api
          });
        }
        if (this.provider.url != '' && this.provider.url != undefined){
          fields.push({
            key: 'URL:',
            value: provider.url
          });
        }
        if (this.provider.k1 != '' && this.provider.k1 != undefined){
          fields.push({
            key: 'key 1:',
            value: provider.k1
          });
        }
        if (this.provider.k2 != '' && this.provider.k2 != undefined){
          fields.push({
            key: 'key 2:',
            value: provider.k2
          });
        }
        if (this.provider.k3 != '' && this.provider.k3 != undefined){
          fields.push({
            key: 'key 3:',
            value: provider.k3
          });
        }
        if (this.provider.cap != '' && this.provider.cap != undefined){
          fields.push({
            key: 'cap:',
            value: provider.cap
          });
        }
        if (this.provider.ggr != '' && this.provider.ggr != undefined){
          fields.push({
            key: 'ggr:',
            value: provider.ggr
          });
        }
        if (provider.params != undefined && Object.keys(provider.params).length){
          Object.keys(provider.params).forEach((item) => {
            fields.push({
              key: item+':',
              value: provider.params[item]
            });
          });
        }
        return fields;
      },
      update(){
        if(this.dialog){
          this.visible = true;
          this.$emit('successEdit');
        }
      },
    }
  }
</script>

<style lang="sass">
</style>